module.exports = __webpack_public_path__ + "img/11.557e95bf.png";